'use strict';
const urlPrefix = `${location.protocol}//localhost:43000`;
import * as NProgress from 'nprogress';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
window.chatAPIScroll = null;
const viewFiles = window.viewFiles;
const oversion = window.oversion;
const _subpath = !location.host.startsWith("localhost") ? "dist" : "src";
window.viewFiles = `/assets/${_subpath}/views`;
window.oversion = new Date().getTime();

window.CONFIG = {
    "routes": {
        "/": {
            templateUrl: function ($routeParams) {
                $routeParams.pagename = 'ohome';
                return `${window.viewFiles}/page.html?v=${window.oversion}`;
            },
            controller: 'PageController',
            resolve: {
                CS: ['$rootScope', 'ScriptLoader', function ($rootScope, ScriptLoader) {
                    return ScriptLoader.load();
                }]
            }
        },
        "/dashboard": {
            templateUrl: function ($routeParams) {
                $routeParams.pagename = 'ohome';
                return `${window.viewFiles}/page.html?v=${window.oversion}`;
            },
            controller: 'PageController',
            resolve: {
                CS: ['ScriptLoader', function (ScriptLoader) {
                    return ScriptLoader.load();
                }]
            }
        },
        "/pagev2/:pagename": {
            templateUrl: window.viewFiles + '/page.html?v=' + window.oversion,
            controller: 'PageController',
            reloadOnSearch: false,
            resolve: {
                CS: ['ScriptLoader', function (ScriptLoader) {
                    return ScriptLoader.load();
                }]
            }

        },
        "/page": {
            templateUrl: window.viewFiles + '/page.html?v=' + window.oversion,
            controller: 'PageController',
            reloadOnSearch: false,
            resolve: {
                CS: ['ScriptLoader', function (ScriptLoader) {
                    return ScriptLoader.load();
                }]
            }
        },
        "/o": {
            templateUrl: function ($routeParams) {
                $routeParams.thisIsLast = '/page';
                return '/o/page?pagename=ohome&____ouv____=1';
            },
            controller: 'PageController',
            resolve: {
                CS: ['ScriptLoader', function (ScriptLoader) {
                    return ScriptLoader.load();
                }]
            }
        },
        "/forgotpassword": {
            templateUrl: window.viewFiles + '/forgotpassword.html?v=' + window.oversion,
            controller: 'JQController',
            reloadOnSearch: false
        },
        "/script_console.bto": {
            templateUrl: window.viewFiles + '/script-console.html?v=' + window.oversion,
            controller: 'scritpConsoleFormController'
        },
        "/:collection/list": {
            templateUrl: window.viewFiles + '/list.html?v=' + window.oversion,
            controller: 'JQController',
            controllerAs: 'GC',
            reloadOnSearch: false,
            resolve: {
                CS: ['$rootScope', 'ScriptLoader', function ($rootScope, ScriptLoader) {
                    return ScriptLoader.load();
                }]
            }
        },
        "/:collection/listv2": {
            templateUrl: window.viewFiles + '/listv2.html?v=' + window.oversion,
            controller: 'JQController',
            controllerAs: 'GC',
            reloadOnSearch: false,
            resolve: {
                CS: ['$rootScope', 'ScriptLoader', function ($rootScope, ScriptLoader) {
                    return ScriptLoader.load();
                }],
                // CM: ['pageServicev2', '$route', function (pageServicev2, $route) {
                //     return pageServicev2.getGridModelv2($route.current.params.collection, "", []);
                // }]
            }
        },
        "/jsonexport/:collection": {
            templateUrl: window.viewFiles + '/filedownload.html?v=' + window.oversion,
            controller: 'RouteController',
            reloadOnSearch: false
        },
        "/xlsx/:collection": {
            templateUrl: window.viewFiles + '/filedownload.html?v=' + window.oversion,
            controller: 'RouteController',
            reloadOnSearch: false
        },
        "/pdfrender/:collection/:id": {
            templateUrl: window.viewFiles + '/filedownload.html?v=' + window.oversion,
            controller: 'RouteController',
            reloadOnSearch: false
        },
        "/:document/:id": {
            templateUrl: window.viewFiles + '/form.html?v=' + window.oversion,
            reloadOnSearch: false,
            controller: 'FormController'
        },
        "/form/:document/:id": {
            templateUrl: window.viewFiles + '/form.html?v=' + window.oversion,
            controller: 'FormController',
            reloadOnSearch: false
        },
        "/uploadfile.bto": {
            templateUrl: function ($routeParams) {
                $routeParams.thisIsLast = '/uploadfile.bto';
                return '/o/uploadfile.bto?____ouv____=1';
            },
            controller: 'RouteController'
        },
        "/template.bto": {
            templateUrl: window.viewFiles + '/obtemplate.html?v=' + window.oversion,
            controller: 'OBTemplateController',
            reloadOnSearch: false
        },
        "/collections.bto": {
            templateUrl: function ($routeParams) {
                return '/o/collections.bto?____ouv____=1';
            },
            controller: 'ManageCollectionController'
        },
        "/event.bto": {
            templateUrl: window.viewFiles + '/calendar.tpl.html?v=' + window.oversion,
            controller: 'CalendarCtrl'
        },
        "/canvas.bto": { templateUrl: window.viewFiles + '/canvas.html?v=' + window.oversion, controller: 'canvasController' },
        "/login.bto": { templateUrl: window.viewFiles + '/loginv3.html?v=' + window.oversion, controller: 'LoginCtrl' },
        "/userprofile.bto": { templateUrl: window.viewFiles + '/user.html?v=' + window.oversion, controller: 'RouteController' },
        "/report.bto": {
            templateUrl: window.viewFiles + '/reporttemplate.html?v=' + window.oversion,
            controller: 'canvasController'
        },
        "/assets/:pathorfile1": {
            templateUrl: function ($routeParams) {
                return `/assets/${$routeParams.pathorfile1}`;
            },
            controller: 'RouteController'
        },
        "/beta": {
            templateUrl: function ($routeParams) {
                return `/beta`;
            },
            controller: 'RouteController'
        },
        "/assets/:pathorfile1/:pathorfile2": {
            templateUrl: function ($routeParams) {
                return `/assets/${$routeParams.pathorfile1}/${$routeParams.pathorfile2}`;
            },
            controller: 'RouteController'
        },
        "/maintenance.bto": { templateUrl: '/assets/dist/maintain.html?v=' + oversion, controller: 'RouteController' },
        "/error": { templateUrl: viewFiles + '/error-500.html?v=' + oversion, controller: 'RouteController' },
        "/error404": { templateUrl: viewFiles + '/error-404.html?v=' + oversion, controller: 'RouteController' }
    }
};

var appConfig = window.appConfig || {};

appConfig.menu_speed = 200;

appConfig.smartSkin = "smart-style-0";

appConfig.skins = [{
    name: "smart-style-0",
    logo: "styles/img/logo.png",
    class: "btn btn-block btn-xs txt-color-white margin-right-5",
    style: "background-color:#4E463F;",
    label: "Smart Default"
},

{
    name: "smart-style-1",
    logo: "styles/img/logo-white.png",
    class: "btn btn-block btn-xs txt-color-white",
    style: "background:#3A4558;",
    label: "Dark Elegance"
},

{
    name: "smart-style-2",
    logo: "styles/img/logo-blue.png",
    class: "btn btn-xs btn-block txt-color-darken margin-top-5",
    style: "background:#fff;",
    label: "Ultra Light"
},

{
    name: "smart-style-3",
    logo: "styles/img/logo-pale.png",
    class: "btn btn-xs btn-block txt-color-white margin-top-5",
    style: "background:#f78c40",
    label: "Google Skin"
},

{
    name: "smart-style-4",
    logo: "styles/img/logo-pale.png",
    class: "btn btn-xs btn-block txt-color-white margin-top-5",
    style: "background: #bbc0cf; border: 1px solid #59779E; color: #17273D !important;",
    label: "PixelSmash"
},

{
    name: "smart-style-5",
    logo: "styles/img/logo-pale.png",
    class: "btn btn-xs btn-block txt-color-white margin-top-5",
    style: "background: rgba(153, 179, 204, 0.2); border: 1px solid rgba(121, 161, 221, 0.8); color: #17273D !important;",
    label: "Glass"
}
];

appConfig.sound_path = "sound/";

appConfig.sound_on = true;

/*
 * DEBUGGING MODE
 * debugState = true; will spit all debuging message inside browser console.
 * The colors are best displayed in chrome browser.
 */

appConfig.debugState = false;
appConfig.debugStyle = 'font-weight: bold; color: #00f;';
appConfig.debugStyle_green = 'font-weight: bold; font-style:italic; color: #46C246;';
appConfig.debugStyle_red = 'font-weight: bold; color: #ed1c24;';
appConfig.debugStyle_warning = 'background-color:yellow';
appConfig.debugStyle_success = 'background-color:green; font-weight:bold; color:#fff;';
appConfig.debugStyle_error = 'background-color:#ed1c24; font-weight:bold; color:#fff;';
appConfig.voice_command = true;
appConfig.voice_command_auto = false;

appConfig.voice_command_lang = 'en-US';
/*
 *  Use localstorage to remember on/off (best used with HTML Version)
 */
appConfig.voice_localStorage = false;
/*
 * Voice Commands
 * Defines all voice command variables and functions
 */
if (appConfig.voice_command) {

    appConfig.commands = {

        'show dashboard': function () {
            window.location.hash = "dashboard";
        },
        'show inbox': function () {
            window.location.hash = "inbox/";
        },
        'show graphs': function () {
            window.location.hash = "graphs/flot";
        },
        'show flotchart': function () {
            window.location.hash = "graphs/flot";
        },
        'show morris chart': function () {
            window.location.hash = "graphs/morris";
        },
        'show inline chart': function () {
            window.location.hash = "graphs/inline-charts";
        },
        'show dygraphs': function () {
            window.location.hash = "graphs/dygraphs";
        },
        'show tables': function () {
            window.location.hash = "tables/table";
        },
        'show data table': function () {
            window.location.hash = "tables/datatable";
        },
        'show jquery grid': function () {
            window.location.hash = "tables/jqgrid";
        },
        'show form': function () {
            window.location.hash = "forms/form-elements";
        },
        'show form layouts': function () {
            window.location.hash = "forms/form-templates";
        },
        'show form validation': function () {
            window.location.hash = "forms/validation";
        },
        'show form elements': function () {
            window.location.hash = "forms/bootstrap-forms";
        },
        'show form plugins': function () {
            window.location.hash = "forms/plugins";
        },
        'show form wizards': function () {
            window.location.hash = "forms/wizards";
        },
        'show bootstrap editor': function () {
            window.location.hash = "forms/other-editors";
        },
        'show dropzone': function () {
            window.location.hash = "forms/dropzone";
        },
        'show image cropping': function () {
            window.location.hash = "forms/image-editor";
        },
        'show general elements': function () {
            window.location.hash = "ui/general-elements";
        },
        'show buttons': function () {
            window.location.hash = "ui/buttons";
        },
        'show fontawesome': function () {
            window.location.hash = "ui/icons/fa";
        },
        'show glyph icons': function () {
            window.location.hash = "ui/icons/glyph";
        },
        'show flags': function () {
            window.location.hash = "ui/icons/flags";
        },
        'show grid': function () {
            window.location.hash = "ui/grid";
        },
        'show tree view': function () {
            window.location.hash = "ui/treeview";
        },
        'show nestable lists': function () {
            window.location.hash = "ui/nestable-list";
        },
        'show jquery U I': function () {
            window.location.hash = "ui/jqui";
        },
        'show typography': function () {
            window.location.hash = "ui/typography";
        },
        'show calendar': function () {
            window.location.hash = "calendar";
        },
        'show widgets': function () {
            window.location.hash = "widgets";
        },
        'show gallery': function () {
            window.location.hash = "gallery";
        },
        'show maps': function () {
            window.location.hash = "gmap-xml";
        },
        'go back': function () {
            history.back(1);
        },
        'scroll up': function () {
            $('html, body').animate({ scrollTop: 0 }, 100);
        },
        'scroll down': function () {
            $('html, body').animate({ scrollTop: $(document).height() }, 100);
        },
        'hide navigation': function () {
            if ($(":root").hasClass("container") && !$(":root").hasClass("menu-on-top")) {
                $('span.minifyme').trigger("click");
            }
            else {
                $('#hide-menu > span > a').trigger("click");
            }
        },
        'show navigation': function () {
            if ($(":root").hasClass("container") && !$(":root").hasClass("menu-on-top")) {
                $('span.minifyme').trigger("click");
            }
            else {
                $('#hide-menu > span > a').trigger("click");
            }
        },
        'mute': function () {
            appConfig.sound_on = false;
            $.smallBox({
                title: "MUTE",
                content: "All sounds have been muted!",
                color: "#a90329",
                timeout: 4000,
                icon: "fa fa-volume-off"
            });
        },
        'sound on': function () {
            appConfig.sound_on = true;
            $.speechApp.playConfirmation();
            $.smallBox({
                title: "UNMUTE",
                content: "All sounds have been turned on!",
                color: "#40ac2b",
                sound_file: 'voice_alert',
                timeout: 5000,
                icon: "fa fa-volume-up"
            });
        },
        'stop': function () {
            smartSpeechRecognition.abort();
            $(":root").removeClass("voice-command-active");
            $.smallBox({
                title: "VOICE COMMAND OFF",
                content: "Your voice commands has been successfully turned off. Click on the <i class='fa fa-microphone fa-lg fa-fw'></i> icon to turn it back on.",
                color: "#40ac2b",
                sound_file: 'voice_off',
                timeout: 8000,
                icon: "fa fa-microphone-slash"
            });
            if ($('#speech-btn .popover').is(':visible')) {
                $('#speech-btn .popover').fadeOut(250);
            }
        },
        'help': function () {

            $('#voiceModal').removeData('modal').modal({
                remote: "app/layout/partials/voice-commands.tpl.html",
                show: true
            });
            if ($('#speech-btn .popover').is(':visible')) {
                $('#speech-btn .popover').fadeOut(250);
            }

        },
        'got it': function () {
            $('#voiceModal').modal('hide');
        },
        'logout': function () {
            $.speechApp.stop();
            window.location = $('#logout > span > a').attr("href");
        }
    };
}

appConfig.apiRootUrl = '/api';

window.appConfig = appConfig;

window.chartColors = {
    red: 'rgb(255, 99, 132)',
    orange: 'rgb(255, 159, 64)',
    yellow: 'rgb(255, 205, 86)',
    green: 'rgb(75, 192, 192)',
    blue: 'rgb(54, 162, 235)',
    purple: 'rgb(153, 102, 255)',
    grey: 'rgb(201, 203, 207)'
};

window.chartColorsHex = {
    red: '#ff6384',
    green: '#4bc0c0',
    orange: '#ff9f40',
    yellow: '#ffcd56',
    blue: '#36a2eb',
    purple: '#9966ff',
    grey: '#c9cbcf'
};

NProgress.configure({
    easing: 'ease',
    minimum: 0.2,
    speed: 500,
    trickleRate: 0.1,
    trickleSpeed: 200
});

window.scroll({
    top: 2500,
    left: 0,
    behavior: 'smooth'
});

window.s2ab = (s) => {
    if (typeof ArrayBuffer !== 'undefined') {
        var buf = new ArrayBuffer(s.length);
        var view = new Uint8Array(buf);
        for (var i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
        return buf;
    }
    else {
        var buf = new Array(s.length);
        for (var i = 0; i !== s.length; ++i) buf[i] = s.charCodeAt(i) & 0xFF;
        return buf;
    }
};

window.export_table_to_excel = (id, type, fn, cd, dateNF, raw) => {
    let wb = XLSX.utils.table_to_book(document.getElementById(id), {
        sheet: "Sheet",
        cellDates: cd,
        cellStyles: true,
        raw: raw || false,
        dateNF: dateNF || 'dd"."mm"."yyyy'
    });
    let wbout = XLSX.write(wb, {
        bookType: type,
        bookSST: true,
        type: 'binary'
    });
    let fname = fn || 'test.' + type;
    try {
        saveAs(new Blob([s2ab(wbout)], {
            type: "application/octet-stream"
        }), fname);
    }
    catch (e) {
        if (typeof console !== 'undefined') console.log(e, wbout);
    }
    return wbout;
};

window.export_table_to_sheet = (id, type, fn, cd, dateNF, raw) => {
    let wb = XLSX.utils.table_to_sheet(document.getElementById(id), {
        sheet: "Sheet",
        cellDates: cd,
        cellStyles: true,
        raw: raw || false,
        dateNF: dateNF || 'dd"."mm"."yyyy'
    });
    let wbout = XLSX.write(wb, {
        bookType: type,
        bookSST: true,
        type: 'binary'
    });
    let fname = fn || 'test.' + type;
    try {
        saveAs(new Blob([s2ab(wbout)], {
            type: "application/octet-stream"
        }), fname);
    }
    catch (e) {
        if (typeof console !== 'undefined') console.log(e, wbout);
    }
    return wbout;
};

window.export_table_to_csv = (id, type, fn) => {
    let wb = XLSX.utils.table_to_book(document.getElementById(id), {
        sheet: "Sheet",
        cellDates: true,
        cellStyles: true
    });
    let wbout = XLSX.write(wb, {
        bookType: type,
        bookSST: true,
        type: 'binary'
    });
    let fname = fn || 'test.' + type;
    try {
        saveAs(new Blob([s2ab(wbout)], {
            type: "application/octet-stream"
        }), fname);
    }
    catch (e) {
        if (typeof console !== 'undefined') console.log(e, wbout);
    }
    return wbout;
};

window.export_data_to_csv = (data, fn) => {
    let ws = XLSX.utils.json_to_sheet(data);

    /* add to workbook */
    let wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet");

    let wbout = XLSX.write(wb, {
        bookType: "csv",
        bookSST: true,
        type: 'array',
        cellDates: true,
        cellStyles: true
    });
    let fname = fn || 'test.' + type;
    try {
        saveAs(new Blob([wbout], { type: "application/octet-stream" }), fname);
    }
    catch (e) {
        if (typeof console !== 'undefined') console.log(e, wbout);
    }
    return wbout;
};

window.toPdf = (zoneid, opts) => {

    NProgress.start();
    let HTML = $('#' + zoneid).html();
    let postData = {};
    // postData._csrf = obto.scope._csrf;
    postData.html = HTML;
    postData.fontsize = opts.fontsize || "0.8em";
    postData.orientation = opts.orientation || "potrait";
    postData.paperFormat = opts.paperFormat || "A4";
    postData.margin = opts.margin || {
        top: "0.5cm",
        left: "0.5cm",
        bottom: "0.5cm",
        right: "0.5cm "
    };

    let xhr = new XMLHttpRequest();
    xhr.open("POST", '/htmltopdf.bto', true);
    xhr.responseType = "arraybuffer";

    //Send the proper header information along with the request
    xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
    xhr.setRequestHeader("Authorization", 'Bearer ' + JSON.parse(window.localStorage.getItem("ob")).token);

    xhr.onreadystatechange = function () { //Call a function when the state changes.
        if (this.readyState === XMLHttpRequest.DONE && this.status === 200) {
            // Request finished. Do processing here.
            NProgress.done();
            let blob = new Blob([xhr.response], {
                type: 'application/pdf'
            });
            NProgress.done();
            // $scope.viewer.alwayshidden = false;
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(blob); // for IE
            }
            else {
                let fileURL = URL.createObjectURL(blob);
                let newWin = window.open(fileURL);
                newWin.focus(); // newWin.reload();
            }
        }
    };
    xhr.send($.param(postData));

};

let helpers = {
    buildDropdown: function (result, dropdown, emptyMessage) {
        // Remove current options
        dropdown.html('');
        // Add the empty option with the empty message
        dropdown.append('<option value="">' + emptyMessage + '</option>');
        // Check result isnt empty
        if (result != '') {
            // Loop through each of the results and append the option to the dropdown
            $.each(result, function (k, v) {
                dropdown.append('<option value="' + v.id + '">' + v.name + '</option>');
            });
        }
    }
};

/*
 * END APP.appConfig
 */
